import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { LanguageService } from '../../../../../shared/services/translations/language.service';
import { ApiErrorService } from '../../../../../shared/services/api-error.service';
import { AuthApiService } from '../../../services/auth-api.service';
import { ToastNotificationService } from '../../../../../notifications/services/toast-notification.service';
import { ToastNotificationType, ToastPosition } from '../../../../../notifications/models/toast-notification-type';

@Component({
  selector: 'app-reset-password',
  imports: [
    RouterLink,
    NgIf,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {

  private fb = inject(FormBuilder);
  private authApiService = inject(AuthApiService);
  private router = inject(Router);

  loading = false;
  languageService = inject(LanguageService);
  apiErrorService = inject(ApiErrorService);
  toastNotificationService = inject(ToastNotificationService);
  translate = inject(TranslateService);

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;

    this.authApiService.requestPasswordResetOtp({
      email: this.form.value.email!
    })
    .pipe(
      finalize(() => this.loading = false)
    )
    .subscribe({
      next: (response) => {
        console.log(response);
        sessionStorage.setItem("email_to_reset", this.form.value.email!);
        this.toastNotificationService.createNotification(this.translate.instant('auth.reset_password.toast_success_message'), ToastNotificationType.SUCCESS, this.translate.instant('auth.reset_password.toast_success_title'), ToastPosition.TOP_RIGHT);
        this.router.navigate(['/reset-password-otp']);
        // Navigate to OTP page or show success message
      },
      error: (error) => {
        if (error?.error?.code === 'EMAIL_NOT_REGISTERED') {
          this.toastNotificationService.createNotification(
            this.translate.instant('auth.reset_password.email_not_registered'),
            ToastNotificationType.ERROR,
            "",
            ToastPosition.TOP_RIGHT
          );
          return;
        }
        this.toastNotificationService.createNotification(this.apiErrorService.getDisplayMessage(error, this.translate.instant('auth.reset_password.toast_error_message')), ToastNotificationType.ERROR, this.translate.instant('auth.reset_password.toast_error_title'), ToastPosition.TOP_RIGHT);
      }
    });
  }

}
